export const ECredit = {
    ADD: 'ADD',
    EDIT: 'EDIT',
    LAST:'LAST'
}